import React from 'react';
import { Grid, Link } from '@material-ui/core';

import './email-validation.less';

export default function EmailValidation({ email, isActiveStep }) {
	return (
		<Grid container spacing={3} className="step-container email-validation">
			<Grid item xs={12}>
				<h5 className="step-title" align="center">
					Check Your Email!
				</h5>
			</Grid>
			<Grid item xs={12} className="check-your-email-img-container">
				<img src="/img/self-service/check-your-email.svg" alt="check your email" />
			</Grid>
			<Grid item xs={12}>
				<div className="step-description">
					{"You're almost there. We sent you an email to "}
					<strong>{email}</strong>
					<br />
					<br />
					{
						'Click the link in the email to confirm your email address, and access your new account.'
					}
				</div>
			</Grid>

			<Grid item xs={12}>
				<div className="having-trouble">
					{"Didn't get the email?"}
					<br />
					<Link
						href="mailto:support@totango.com?subject=Please send me a link to Totango"
						style={{ cursor: 'pointer' }}
					>
						Verify by sending us an email
					</Link>
				</div>
			</Grid>
		</Grid>
	);
}
